<template>
  <div class="news">
    <div class="nav-box">
      <p class="title">新闻</p>
      <p class="caption">THE NEWS</p>
    </div>
    <div class="news-box">
      <div v-if="newsList.length > 0">
        <div class="dot-box">
          <p :class="index == showTop ? 'active': ''" :key="index" @click="showClick(index)" class="nav-dot" v-for="(item, index) in newsListTop"></p>
        </div>
        <div :key="index" class="list-nav" v-for="(item, index) in newsListTop">
          <template v-if="index == showTop">
            <!--            <div class="news-img" :style="'background:url(' + item.banner +') no-repeat/cover 100%'">{{item.banner}}</div>-->
            <div class="news-img">
              <img :src="item.banner">
              <div class="left" @click="showClicks(showTop-1)" :type="showTop==0?'disabled':''"></div>
              <div class="right" @click="showClicks(showTop+1)" :type="showTop==2?'disabled':''"></div>
            </div>
            <div class="news-info">
              <div class="news-title">
                <p class="title">{{item.title}}</p>
              </div>
              <p class="news-time">{{getUnixTime(item.publishTime).date}}</p>
              <p class="news-synopsis" v-html="item.content"></p>
              <p @click="newsClick(item)" class="click">点击查看</p>
            </div>
          </template>
        </div>
        <div class="news-list">
          <div :key="index" class="list" v-for="(item, index) in newsList">
            <div class="left-time">
              <p class="day">{{getUnixTime(item.publishTime).day}}</p>
              <p class="time">{{getUnixTime(item.publishTime).year}}</p>
            </div>
            <div class="right-info">
              <p class="list-title">{{item.title}}</p>
              <p class="list-text" v-html="item.content"></p>
              <p @click="newsClick(item)" class="info-click">详情 >></p>
            </div>
          </div>
        </div>
        <Page :page="page" :size="limit" :total="count" @onPage="onPage"></Page>
      </div>
      <div v-else>
        <el-empty :description="empty"></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import Page from "@/components/common/Page.vue"
  import {listContent} from "../../utils/router/news.api";

  export default {
    components: {Page},
    data() {
      return {
        newsListTop: [],
        newsList: [],
        page: 1,
        limit: 10,
        count: 0,
        newImg: require("../../assets/image/news/news.png"),
        empty: "暂无资源",
        showTop: 0,
      };
    },
    methods: {
      getUnixTime(t) {
        if (t) {
          const reg = /[\u4e00-\u9fa5]/g;
          const time = new Date(parseInt(t) * 1000);
          const zero = (m) => m < 10 && '0' + m;
          return {
            year: time.getFullYear() + '/' + zero(time.getMonth() + 1),
            day: time.getDate(),
            date: time.getFullYear() + '/' + zero(time.getMonth() + 1) + '/' + time.getDate(),
          }
        }
      },
      getNews() {
        listContent({
          typeId: this.$store.state.typeId,
          limit: this.limit,
          page: this.page,
        }).then((res) => {
          console.log(res);
          if (res && res.data.code === 200) {
            if (res && res.data.data) {
              this.newsList = res.data.data.list || [];
              this.count = res.data.data.count
              // 头部三条
              res.data.data.list.map((data) => {
                if (data.banner == "/" || data.banner == '') {
                  // data.banner = require('../../assets/image/news/news.png')
                  data.banner = ''
                } else {
                  data.banner = "/banner/" + data.banner;
                }
              });
              this.newsListTop = res.data.data.list.slice(0, 3) || [];
              sessionStorage.setItem(
                "newsdata",
                JSON.stringify(res.data.data.list)
              );
            }
          }
        });
      },
      showClick(index) {
        this.showTop = index;
      },
      showClicks(index) {
        console.log(index, this.showTop);
        if (index < 0) {
          return
        } else if (index >= 3) {
          return
        } else {
          this.showTop = index
        }
      },
      newsClick(row) {
        this.$router.push({
          path: "/newsdetails",
          query: {
            id: row.id,
          },
        });
      },
      onPage(page) {
        this.page = page
        this.getNews()
      },
    },
    created() {
      this.getNews();
    },
  };
</script>

<style lang="less" scoped>
  .news {
    margin-bottom: 2.083rem;

    .nav-box {
      height: 6.792rem;
      background: url("../../assets//image/news/nav.png");
      color: #582800;
      text-align: center;
      padding-top: 2.719rem;
      margin-bottom: 1.042rem;

      .title {
        font-weight: bold;
        font-size: 1.458rem;
        padding-bottom: 0.245rem;
        letter-spacing: 2px;
      }

      .caption {
        font-size: 0.938rem;
      }
    }

    .news-box {
      width: 62.5rem;
      // height: 71.875rem;
      background-color: #ffffff;
      padding: 1.563rem 1.042rem;
      position: relative;
      margin: auto;


      .list-nav {
        display: flex;

        .news-img {
          width: 30.208rem;
          height: 16.771rem;
          // background: url("../../assets/image/news/news.png");
          position: relative;

          &:hover {
            .left, .right {
              display: flex;
            }
          }

          .left, .right {

            cursor: pointer;
            position: absolute;
            height: 3.25rem;
            width: 1.064rem;
            font-size: 1rem;
            font-family: element-icons !important;
            font-weight: 800;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #ffffff;
            background-color: rgba(206, 206, 206, 0.6);
            display: none;

            &[type=disabled] {
              cursor: not-allowed;
              pointer-events: none;
            }
          }

          .left {
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            border-top-right-radius: 0.729rem;
            border-bottom-right-radius: 0.729rem;

            &::before {
              content: '\e6de';
            }
          }

          .right {
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            border-top-left-radius: 0.729rem;
            border-bottom-left-radius: 0.729rem;

            &::before {
              content: '\e6e0';
            }
          }

          img {
            width: 100%;
            height: 100%;
          }
        }

        .news-info {
          width: 27.865rem;
          color: #333;
          margin-left: 1.875rem;
          padding-top: 0.99rem;

          .news-title {
            display: flex;
            font-size: 1.25rem;
            font-weight: bold;

            .title {
              flex: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding-right: 4rem;
            }
          }

          .news-time {
            color: #808080;
            font-size: 0.833rem;
            padding-top: 0.281rem;
            padding-bottom: 1rem;
          }

          .news-synopsis {
            display: -webkit-box;
            font-size: 0.833rem;
            line-height: 26px;
            height: auto;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 6;
            overflow: hidden;
            text-indent: 2em;

            /deep/ img {
              display: none;
            }
          }

          .click {
            width: 5.833rem;
            height: 1.563rem;
            border: solid 0.052rem #b1222b;
            border-radius: 0.208rem;
            color: #b1222b;
            cursor: pointer;
            font-size: 0.833rem;
            text-align: center;
            line-height: 1.563rem;
            margin-top: 1.279rem;
          }
        }
      }

      .dot-box {
        display: flex;
        position: absolute;
        right: 1.042rem;
        top: 2.99rem;

        .nav-dot {
          width: 0.417rem;
          height: 0.417rem;
          background-color: #ccc;
          border-radius: 0.208rem;
          cursor: pointer;
          margin: 0 0.208rem;
        }

        .active {
          width: 0.617rem;
          height: 0.417rem;
          background-color: #b1222b;
        }
      }

      .news-list {
        display: flex;
        padding-top: 5.729rem;
        flex-wrap: wrap;
        justify-content: space-between;

        .list {
          // width: 28.75rem;
          display: flex;
          margin-bottom: 3.125rem;

          .left-time {
            width: 5.729rem;
            height: 5.729rem;
            background-color: #b1222b;
            color: #fff;
            padding-top: 1rem;
            text-align: center;

            .day {
              font-size: 1.875rem;
            }

            .time {
              font-size: 1.354rem;
            }
          }

          .right-info {
            width: 21.25rem;
            color: #333;
            position: relative;
            margin-left: 1.771rem;

            .list-title {
              font-size: 1.146rem;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .list-text {
              display: -webkit-box;
              font-size: 0.833rem;
              padding-top: 0.529rem;
              line-height: 1.25rem;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              text-indent: 2rem;

              /deep/ img {
                display: none;
              }

              /deep/ p {
                font-size: 16px;
                line-height: 25px;
                color: #0C0C0C;
              }

            }

            .info-click {
              color: #b1222b;
              cursor: pointer;
              font-size: 0.833rem;
              padding-top: 0.529rem;
              position: absolute;
              right: 0;
            }
          }
        }
      }
    }
  }
</style>
